import { render } from "./GradientBg.vue?vue&type=template&id=5a16b41a&scoped=true&ts=true"
import script from "./GradientBg.vue?vue&type=script&lang=ts"
export * from "./GradientBg.vue?vue&type=script&lang=ts"

import "./GradientBg.vue?vue&type=style&index=0&id=5a16b41a&scoped=true&lang=sass"

import exportComponent from "/Users/sotenck/GIT/kunden/iconomy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a16b41a"]])

export default __exports__